// src/pages/TrackingPage.jsx (ACTUALIZADO FINAL)
import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import ImgHeader from '../components/ImgHeader';
import Footer from '../components/Footer';
import { useTracking } from '../hooks/useTracking';

const TrackingPage = () => {
  const { trackingNumber: urlTrackingNumber } = useParams();
  const location = useLocation();
  const tracking = useTracking();

  const {
    requestAuth,
    hasProcessedUrlTracking,
    markUrlTrackingAsProcessed,
    currentStep,
    resetTracking, // ✅ Usar resetTracking en lugar de resetForNewSearch
    pendingTrackingNumber,
  } = tracking;

  // ✅ Efecto para procesar número desde URL
  useEffect(() => {
    // Solo procesar si hay un número en la URL
    if (urlTrackingNumber) {
      console.log('🔗 URL detectada:', urlTrackingNumber);

      // Formatear el número
      const formattedNumber = /^\d{4}$/.test(urlTrackingNumber)
        ? `#${urlTrackingNumber}`
        : urlTrackingNumber;

      // ✅ NUEVA LÓGICA: Solo marcar como procesado si es un número diferente
      if (formattedNumber !== pendingTrackingNumber) {
        console.log('🚀 Procesando nuevo número:', formattedNumber);
        markUrlTrackingAsProcessed();
        requestAuth(formattedNumber, true);
      } else {
        console.log('⏭️ Ya estamos procesando este número, ignorando...');
      }
    }
  }, [
    urlTrackingNumber,
    requestAuth,
    pendingTrackingNumber,
    markUrlTrackingAsProcessed,
  ]);

  // ✅ Efecto para resetear VISUALMENTE cuando vamos a /tracking sin número
  useEffect(() => {
    if (!urlTrackingNumber && location.pathname === '/tracking') {
      const hasJustLeftResults = localStorage.getItem('just_left_results');

      if (!hasJustLeftResults && currentStep !== 'search') {
        console.log('📄 Cambiando a vista de búsqueda...');
        resetTracking();
      }

      // Limpiar flag
      localStorage.removeItem('just_left_results');
    }
  }, [urlTrackingNumber, location.pathname, currentStep, resetTracking]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col">
      <Header />
      <ImgHeader {...tracking} />
      <Footer />
    </div>
  );
};

export default TrackingPage;
